import React from 'react';

interface ProfileIconProps {
  size?: number;
  className?: string;
}

/**
 * Default profile icon component.
 * Displays a user profile icon when no profile picture is available.
 */
export const ProfileIcon: React.FC<ProfileIconProps> = ({ 
  size = 24, 
  className = '' 
}) => {
  return (
    <svg 
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
};
